<template>
  <section class="px-8 md:px-16 py-16 md:py-24 border-t border-secondary/50">
    <div
      class="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center"
      :class="{ 'md:grid-flow-col-dense': isReversed }"
      data-aos="fade-up"
    >
      <!-- Left Text Content -->
      <div :class="{ 'md:col-start-2': isReversed }" data-aos="fade-right"  data-aos-duration="800">
        <h3 class="text-2xl md:text-3xl font-bold mb-4">{{ title }}</h3>
        <p v-if="subtitle" class="text-accent font-medium mb-6">
          {{ subtitle }}
        </p>
        <div class="w-16 h-0.5 bg-accent mb-8"></div>
        <p class="text-lg leading-relaxed text-muted-foreground mb-8">
          {{ description }}
        </p>

        <div class="space-y-4 mb-8">
          <div
            v-for="(highlight, index) in highlights"
            :key="index"
            class="flex items-start space-x-3"
            data-aos="fade-right"
             data-aos-duration="800"
          >
            <CheckCircle class="w-5 h-5 text-accent mt-0.5 flex-shrink-0" />
            <span class="text-muted-foreground">{{ highlight }}</span>
          </div>
        </div>

        <a
          v-if="websiteUrl"
          :href="websiteUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="inline-flex items-center space-x-2 bg-accent hover:bg-accent/80 text-background px-6 py-3 rounded-lg transition-all duration-300 group"
          data-aos="fade-up"
          data-aos-delay="800"
        >
          <span class="font-medium">{{ websiteLabel || "Visit Website" }}</span>
          <ExternalLink
            class="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300"
          />
        </a>
      </div>

      <!-- Right Image Content -->
      <div
        :class="{ 'md:col-start-1': isReversed }"
        :data-aos="isReversed ? 'fade-right' : 'fade-left'"
        data-aos-delay="800"
      >
        <div class="relative">
          <div
            v-if="computedImage"
            class="aspect-[4/3] bg-white rounded-lg p-8 flex items-center justify-center"
          >
            <img
              :src="computedImage"
              :alt="title"
              class="max-w-full max-h-full object-contain"
            />
          </div>
          <div
            v-else
            class="aspect-[4/3] bg-gradient-to-br from-accent/20 to-secondary/50 rounded-lg p-8 flex items-center justify-center"
          >
            <div class="text-center">
              <div
                class="w-16 h-16 bg-accent/20 rounded-full mx-auto mb-4 flex items-center justify-center"
              >
                <div class="w-8 h-8 bg-accent rounded-full"></div>
              </div>
              <p class="text-muted-foreground">Project Visual</p>
            </div>
          </div>
          <div
            class="absolute -top-4 -right-4 w-24 h-24 bg-accent/10 rounded-full blur-xl"
          ></div>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
import { CheckCircle, ExternalLink } from "lucide-vue-next";
// import { Motion } from '@motionone/vue'
import AOS from "aos";
import "aos/dist/aos.css";

// Static images
import rwbuildLogo from "@/assets/rwbuildLogo.png";
import guhembaImage from "@/assets/guhembaImage.png";
import rwanda912Logo from "@/assets/rwanda912Logo.png";

export default {
  name: "ProjectSection",
  components: {
    // Motion,
    CheckCircle,
    ExternalLink,
  },
  props: {
    title: String,
    subtitle: String,
    description: String,
    highlights: {
      type: Array,
      default: () => [],
    },
    isReversed: {
      type: Boolean,
      default: false,
    },
    customImage: {
      type: String,
      default: null,
    },
    websiteUrl: {
      type: String,
      default: null,
    },
    websiteLabel: {
      type: String,
      default: "",
    },
  },
  computed: {
    computedImage() {
      if (this.customImage) return this.customImage;
      if (this.title && this.title.includes("RWbuild")) return rwbuildLogo;
      if (this.title && this.title.includes("Guhemba")) return guhembaImage;
      if (this.title && this.title.includes("912Rwanda")) return rwanda912Logo;
      return null;
    },
  },
  mounted() {
    AOS.init({
      once: true, // animation triggers once when scrolled into view
      duration: 1200, // default animation duration
    });
  },
};
</script>
